import {
  ChatMessage,
  ChatMessageStatus,
  InternalMessageStatus,
  SendQuestionReq,
} from '../../../models';

export const questionToMessage = (question: SendQuestionReq): ChatMessage => ({
  id: question.messageId,
  chatId: question.chatId,
  createdAt: new Date().toString(),
  status: ChatMessageStatus.InProgress,
  request: question.request,
  reply: '',
  lang: null,
  internalStatus: InternalMessageStatus.pending,
  links: [],
  replyType: null,
  chatStarted: question.chatStarted,
});
